import type { ImportInvoicePayload, ImportInvoiceResponse } from './types';

import { ENDPOINT } from '~/constants/endpoints';

import { vestigasApi } from '~/services/kyClient';

import {
  zodImportInvoicePayloadSchema,
  zodImportInvoiceResponseSchema,
} from './validations';

/**
 * Creates invoices from files already staged through `files/upload_link`.
 *
 * @param payload - The owner company and the staged files.
 * @returns The created invoices.
 * @see https://app.dev.vestigas.com/redoc#tag/Invoices/operation/import_invoice_invoices_import_post
 */
export async function importInvoice(payload: ImportInvoicePayload) {
  return vestigasApi
    .post(ENDPOINT.INVOICE.IMPORT(), {
      json: payload,
      validate: {
        body: zodImportInvoicePayloadSchema,
        isResponseSensitive: true,
        response: zodImportInvoiceResponseSchema,
      },
    })
    .json<ImportInvoiceResponse>();
}
